// This code adds a video release to the single product at `/products/primal-pathways-of-consciousness` (the 2026 workshop).
// IT ONLY WORKS ON THAT PAGE! IF THE PRODUCT HANDLE CHANGES, THIS CODE WILL STOP WORKING!
// It uses Infinite Options to add a checkbox for the video and photography release.

// The script tag in `layout/theme.liquid` uses `defer`, so the DOM is already
// parsed by the time this file runs. No DOMContentLoaded wrapper is needed.

// Edit this to change the video/photo release text
const videoWaiverHTML = `
  <div class="video-waiver-wrapper video-waiver-wrapper-collapsed">
    <h2>Video Waiver</h2>
    <div id="video-waiver-text" class="video-waiver-text">
      <p><strong>Video and Photography Release</strong></p>
      <p>
        This workshop will be video recorded and photos will be taken.
        Registration for the workshop requires your consent as outlined below.
      </p>
      <p>
        I understand that the workshop for which I am registering will be
        photographed and video recorded, and that these photographs and video
        recordings may contain my name, likeness, statements and/or voice
        (collectively, the "Materials"). I hereby give and forever grant Bonnie
        Bainbridge Cohen, her licensees, heirs, and assignees, the right to use,
        adapt, publish, modify, and reproduce the Materials for any purpose across
        all media now known or created in the future, and in any format, through
        the universe.
      </p>
      <p>
        In consideration of the printing/production deadlines, I hereby waive any
        right that I may have to inspect and approve the finished product or copy
        that may result from the uses of the Materials. I also waive and release
        any claim that I may have against Bonnie Bainbridge Cohen, her licensees,
        heirs, and assignees, based upon or arising from such uses, including
        without limitation, any moral rights of any description, any right to
        approve the use of the Materials, any claims for invasion of privacy,
        violation of the right of publicity, defamation, and/or copyright
        infringement, or for any compensation for such uses.
      </p>
      <p>
        This release will be governed by and construed in accordance with the laws
        of the United States and the State of California, notwithstanding any
        state's conflict of laws or choice of law rules to the contrary. I further
        agree that any actions concerning any dispute relating to this release
        shall be brought in the Superior Court of the State of California, Contra
        Costa County, or in the United States District Court of the Northern
        District of California, and that the prevailing party in any action shall
        be entitled to receive from the other party its reasonable attorneys' fees
        and costs.
      </p>
      <p>
        I have read the forgoing and fully understand and confirm my agreement by
        submitting my registration for this workshop. I am of the legal age of
        majority in my state or country and I am authorized to grant the
        permissions, waivers and releases set forth above.
      </p>
    </div>
    <div class="video-waiver-wrapper-fade-out"></div>
    <button
      class="video-waiver-wrapper-expand-button"
      type="button"
      aria-expanded="false"
      aria-controls="video-waiver-text"
    >
      Expand Text
    </button>
  </div>
`;

// This function adds the text to the page and configures the InfiniteOptions settings.
function addReleaseText() {
  // Insert the video/photo release text into the page:
  const targetDiv = document.querySelector(".video-waiver-section");

  // Check if the target div exists
  if (targetDiv) {
    // Insert the HTML at the beginning of the target div
    targetDiv.insertAdjacentHTML("afterbegin", videoWaiverHTML);
  } else {
    console.warn(
      "video waiver: target div with class 'video-waiver-section' not found."
    );
  }

  // Enable the expand button functionality:
  const wrapper = document.querySelector(".video-waiver-wrapper");
  if (!wrapper) return;
  const button = wrapper.querySelector(".video-waiver-wrapper-expand-button");
  if (!button) return;

  // Customize the InfiniteOptions error messages:
  ((window.Shoppad = window.Shoppad || {}),
    (window.Shoppad.apps = window.Shoppad.apps || {}),
    (window.Shoppad.apps.infiniteoptions =
      window.Shoppad.apps.infiniteoptions || {}),
    (window.Shoppad.apps.infiniteoptions.strings =
      window.Shoppad.apps.infiniteoptions.strings || {}),
    (window.Shoppad.apps.infiniteoptions.strings.errorMessages = {
      forTextInputs:
        "Please fill out the required fields before adding this item to cart.",
      forNumberInputs: "Please enter a number before adding this item to cart",
      forCheckboxes:
        "You must check the box to accept the video and photography release before you can register.",
      forMinimumValues:
        "Please select at least %valuesmin options before adding this item to cart",
      forDynamicCheckout:
        "This product cannot be purchased using this checkout method. Please add the item to cart, then proceed to checkout from the cart.",
      forDropdowns: "Please select an option before adding this item to cart",
    }));

  button.addEventListener("click", function (event) {
    // Clicking the button was adding the item to the cart. These lines fixed the problem.
    event.preventDefault(); // Prevent default form behavior, if any
    event.stopPropagation(); // Stop bubbling to parent elements

    const expanded = wrapper.classList.toggle("video-waiver-wrapper-expanded");
    wrapper.classList.toggle("video-waiver-wrapper-collapsed", !expanded);
    // Set max-height inline from the rendered content height so the box
    // fits the waiver text regardless of length. Reading scrollHeight
    // here forces a layout flush, so it reflects the class change made
    // on the line above. Clearing the inline style on collapse lets the
    // stylesheet's collapsed max-height take effect again.
    wrapper.style.maxHeight = expanded ? wrapper.scrollHeight + "px" : "";
    button.setAttribute("aria-expanded", expanded ? "true" : "false");
    button.textContent = expanded ? "Collapse Text" : "Expand Text";
  });

  // Wire up the soft red "you must check the box" notification. The
  // .spb-helptext element is hidden by default via CSS and is only
  // revealed when the user clicks Add to Cart with the required
  // checkbox still unchecked. It hides itself again as soon as the
  // checkbox becomes checked.
  const helptext = document.querySelector(
    ".video-waiver-section .spb-helptext"
  );
  const requiredCheckbox = document.querySelector(
    '.video-waiver-section fieldset[data-required="true"] input[type="checkbox"]'
  );
  const addToCartButton = document.querySelector(
    'form[action*="/cart/add"] [type="submit"], button[name="add"]'
  );

  if (helptext && requiredCheckbox && addToCartButton) {
    // Listen in the capture phase so this runs before InfiniteOptions'
    // own click handler intercepts the submission.
    addToCartButton.addEventListener(
      "click",
      function () {
        if (!requiredCheckbox.checked) {
          helptext.classList.add("video-waiver-warning-visible");
        }
      },
      true
    );

    requiredCheckbox.addEventListener("change", function () {
      if (requiredCheckbox.checked) {
        helptext.classList.remove("video-waiver-warning-visible");
      }
    });
  }
}

// Because Infinite Options loads after the rest of the page, this JavaScript file has to wait for it to be added to the page.
//
// Tip: the old name of InfiniteOptions is customizery, so to find its JS loader, look for the old name in the HTML source.
function waitForInfiniteOptionsToLoad() {
  // Narrow the observed root to the page's main content area when
  // available, falling back to <body>. This avoids invoking the
  // observer callback on mutations elsewhere on the page (header,
  // footer, cart drawer, etc.) since the InfiniteOptions widget mounts
  // inside the product area.
  const root = document.querySelector("main") || document.body;
  let timeoutId;
  const observer = new MutationObserver((mutations, observerInstance) => {
    const wrapper = document.querySelector(
      "#infiniteoptions-container > div.video-waiver-section"
    );
    if (wrapper) {
      clearTimeout(timeoutId);
      addReleaseText();
      // Stop observing
      observerInstance.disconnect();
    }
  });

  observer.observe(root, {
    childList: true,
    subtree: true,
  });

  // If InfiniteOptions never mounts (app uninstalled, network failure,
  // script error), disconnect the observer after 15 seconds so it does
  // not run for the lifetime of the page.
  timeoutId = setTimeout(() => {
    observer.disconnect();
    console.warn(
      "video waiver: InfiniteOptions container never appeared; observer disconnected after 15s"
    );
  }, 15000);
}

// Check to be sure that we're on the right page before running any code.
// This is a defense-in-depth check; layout/theme.liquid also gates the
// script tag itself via `{% if product.handle == ... %}`.
//
// The `/products_preview` entry covers Shopify storefront previews,
// where the URL is `shopifypreview.com/products_preview?preview_key=...`
// instead of `/products/<handle>`. The Liquid gate's handle check still
// applies inside a preview, so only previews of the gated product will
// reach this point.
if (
  [
    "/products/primal-pathways-of-consciousness",
    "/products_preview",
    "/cart",
    // "/products/embodying-inner-spirals-of-the-body",
  ].includes(window.location.pathname)
) {
  waitForInfiniteOptionsToLoad();
}
